import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';
import times from 'lodash/times';
import noop from 'lodash/noop';

import theme from 'src/styles/components/CarouselIndicators.module.scss';

import Button from 'src/components/Button';

class CarouselIndicators extends Component {
    renderIndicators() {
        const {
            IndicatorComponent,
            shouldShowIndicatorDot,
            onIndicatorClick,
            indicatorsCount,
            currentSlide,
            itemsPerScrollContainer
        } = this.props;

        const Indicator = IndicatorComponent || Button;

        if (!shouldShowIndicatorDot) {
            return null;
        }

        if (indicatorsCount === 1) {
            return null;
        }

        return times(indicatorsCount, Number).map((indicator) => (
            <Indicator
              key={indicator}
              neutral={false}
              className={classnames(theme.indicator, {
                  [theme.isActive]: indicator === Math.floor(currentSlide / itemsPerScrollContainer)
              })}
              onClick={() => { onIndicatorClick(indicator); }}
            />
        ));
    }

    render() {
        const {
            CustomIndicatorElement
        } = this.props;

        return (
            <div className={theme.indicatorsContainer}>
                <div className={theme.indicatorsWrapper}>
                    <div className={theme.indicators}>
                        {this.renderIndicators()}
                    </div>
                    <CustomIndicatorElement />
                </div>
            </div>
        );
    }
}

CarouselIndicators.propTypes = {
    IndicatorComponent: PropTypes.func,
    shouldShowIndicatorDot: PropTypes.bool,
    CustomIndicatorElement: PropTypes.func,
    onIndicatorClick: PropTypes.func,
    indicatorsCount: PropTypes.number.isRequired,
    currentSlide: PropTypes.number.isRequired,
    itemsPerScrollContainer: PropTypes.number.isRequired
};

CarouselIndicators.defaultProps = {
    CustomIndicatorElement: () => null,
    onIndicatorClick: noop
};

export default CarouselIndicators;
